
import Components from "slotworks/components/components";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import Contract from "slotworks/utils/contracts/contract";

export function StopSpinCommand(spinRecord: SpinRecord) {
    return new Contract<void>((resolve) => {
        Components.matrix.stopTransition(spinRecord, settingsModel.getQuickSpin()).then(() => {
            if (spinRecord && spinRecord instanceof FreespinRecord) {
                Services.sound.event(SoundEvent.end_freespin);
            } else {
                Services.sound.event(SoundEvent.end_spin);
            }
            resolve(null);
        });
    });
}
